import React, { useState } from 'react';
import axios from '../api/axios';

/**
 * Reusable Export Button Component
 * Downloads CSV files from API endpoints
 */
export default function ExportButton({
  endpoint,
  filename = 'export.csv',
  label = 'Export CSV',
  icon = '📥',
  className = '',
}) {
  const [isExporting, setIsExporting] = useState(false);
  const [error, setError] = useState('');

  const handleExport = async () => {
    setIsExporting(true);
    setError('');

    try {
      const response = await axios.get(endpoint, {
        responseType: 'blob',
        timeout: 30000, // 30 seconds timeout
      });

      // Create download link
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();

      // Cleanup
      link.remove();
      window.URL.revokeObjectURL(url);

    } catch (err) {
      setError('Failed to export. Please try again.');

      // Show error to user
      alert(`Export failed: ${err.response?.data?.message || err.message || 'Please try again'}`);
    } finally {
      setIsExporting(false);
    }
  };

  return (
    <div className="inline-block">
      <button
        onClick={handleExport}
        disabled={isExporting}
        className={`flex items-center gap-2 px-4 py-2 bg-emerald-600 text-white rounded-lg hover:bg-emerald-700 disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200 ${className}`}
        title={`Download ${label}`}
      >
        <span className="text-lg">{icon}</span>
        <span className="font-medium">
          {isExporting ? 'Exporting...' : label}
        </span>
      </button>

      {error && (
        <p className="mt-2 text-xs text-red-600 dark:text-red-400">{error}</p>
      )}
    </div>
  );
}
